import Immutable from 'immutable';
import { handleActions } from 'redux-actions';

const CheckCardState = Immutable.fromJS({

  view: {
    categories: [],
    card: {},
    details: [],
    showModal: false,
    showPhotoBlk: false,
    showRfidConfig: false,
    photos: [],
  },

  rfid: {
    hostname: null,
    port: null,
    name: null,
    sensitivity: null,
    readers: [],
    epcs: [],
    epc: null,
    alreadyDiscard: null,
    entity: {
      hostname: null,
      port: null,
      name: null,
      sensitivity: null,
    },
  },

  request: {
    category: 0,
    note: '',
    itemType: '消防衣',
    photo: "",
    queuing: false,
  },

  alert: {
    style: null,
    message: null
  },

  validation: {
    name: {
      validationState: null,
      helpBlock: null
    },
    hostname: {
      validationState: null,
      helpBlock: null
    },
    port: {
      validationState: null,
      helpBlock: null
    },
    sensitivity: {
      validationState: null,
      helpBlock: null
    },
  },

  isLoadingChipEpcs: false,
  isLoadingPage: false,
  labelId: null,
  showInputLabelId: false,

  previousPage: '/'

});

const checkCardReducer = handleActions({

  QUEUE_PHOTO: (state, { payload }) => {
    let viewObj = state.get('view');
    viewObj = viewObj.set('card', payload.data.card);
    viewObj = viewObj.set('photos', payload.data.photos);

    return state.merge({
      view: viewObj,
      alert: {
        style: payload.alertStyle,
        message: payload.displayMessage
      },
      isLoadingPage: false
    })
  },

  MARK_POP_PHOTO: (state, { payload }) => {
    let requestModel = state.get('request');
    return state.merge({
      request: requestModel.set('queuing', false)
    })
  },

  MARK_QUEUE_PHOTO: (state, { payload }) => {
    let requestModel = state.get('request');
    return state.merge({
      request: requestModel.set('queuing', true),
      alert: {
        style: null,
        message: null
      }
    })
  },

  SET_REMOVE_CHECK_ITEM_TYPE: (state, { payload }) => {
    let requestModel = state.get('request');
    return state.merge({
      request: requestModel.set('itemType', payload)
    })
  },

  SHOW_DEL_CHECK_ITEM_MODAL: (state, { payload }) => {
    let viewObject = state.get('view');
    return state.merge({
      view: viewObject.set('showModal', true)
    })
  },

  SHOW_RFID_CONFIG: (state, { payload }) => {
    let view = state.get('view');
    view = view.set('showRfidConfig', true);

    let rfid = state.get('rfid');
    rfid = rfid.set('readers', payload.data);

    return state.merge({
      view: view,
      rfid: rfid,
    })
  },

  LOADING_CHIP_EPCS: (state, { payload }) => {
    return state.merge({
      isLoadingChipEpcs: true,
      alert: {
        style: null,
        message: null
      },

    })
  },

  SHOW_CHIP_EPCS: (state, { payload }) => {
    let rfid = state.get('rfid');
    rfid = rfid.set('epcs', payload.data);

    return state.merge({
      rfid: rfid,
      isLoadingChipEpcs: false,
      alert: {
        style: payload.alertStyle,
        message: payload.displayMessage
      },
    })
  },

  CLEAN_CHIP_EPCS: (state, { payload }) => {
    let rfid = state.get('rfid');
    rfid = rfid.set('epcs', []);

    return state.merge({
      rfid: rfid,
      alert: {
        style: null,
        message: null
      },
      validation: {
        name: {
          validationState: null,
          helpBlock: null
        },
        hostname: {
          validationState: null,
          helpBlock: null
        },
        port: {
          validationState: null,
          helpBlock: null
        },
        sensitivity: {
          validationState: null,
          helpBlock: null
        },
      }
    })
  },

  SET_CHIP_EPC: (state, { payload }) => {
    let rfid = state.get('rfid');
    rfid = rfid.set('epc', payload.data);

    return state.merge({
      rfid: rfid,
      alert: {
        style: payload.alertStyle,
        message: payload.displayMessage
      },
    })
  },

  SET_CHIP_EPC_2: (state, { payload }) => {
    let rfid = state.get('rfid');
    rfid = rfid.set('epc', payload.data.epc);
    rfid = rfid.set('alreadyDiscard', payload.data.alreadyDiscard);

    return state.merge({
      rfid: rfid,
      alert: {
        style: payload.alertStyle,
        message: payload.displayMessage
      },
    })
  },

  ASSIGN_READER_HOSTNAME: (state, { payload }) => {
    state = state.updateIn(['rfid', 'entity', 'hostname'], (value) => payload);
    return state.merge();
  },

  ASSIGN_READER_NAME: (state, { payload }) => {
    state = state.updateIn(['rfid', 'entity', 'name'], (value) => payload);
    return state.merge();
  },

  ASSIGN_READER_PORT: (state, { payload }) => {
    state = state.updateIn(['rfid', 'entity', 'port'], (value) => payload);
    return state.merge();
  },

  ASSIGN_READER_SENSITIVITY: (state, { payload }) => {
    state = state.updateIn(['rfid', 'entity', 'sensitivity'], (value) => payload);
    return state.merge();
  },

  ASSIGN_SPEEDWAY: (state, { payload }) => {
    let rfid = state.get('rfid');
    rfid = rfid.set('hostname', payload.hostname);
    rfid = rfid.set('port', payload.port);
    rfid = rfid.set('name', payload.name);
    rfid = rfid.set('sensitivity', payload.sensitivity);

    let entity = rfid.get('entity');
    entity = entity.set('hostname', payload.hostname);
    entity = entity.set('port', payload.port);
    entity = entity.set('name', payload.name);
    entity = entity.set('sensitivity', payload.sensitivity);
    rfid = rfid.set('entity', entity);   

    return state.merge({
      rfid: rfid,
    })
  },

  HIDE_RFID_CONFIG: (state, { payload }) => {
    let viewObject = state.get('view');
    return state.merge({
      view: viewObject.set('showRfidConfig', false)
    })
  },

  SHOW_PHOTO_BLK: (state, { payload }) => {
    let viewObject = state.get('view');
    return state.merge({
      view: viewObject.set('showPhotoBlk', true)
    })
  },

  HIDE_DEL_CHECK_ITEM_MODAL: (state, { payload }) => {
    let viewObject = state.get('view');
    return state.merge({
      view: viewObject.set('showModal', false)
    })
  },

  HIDE_PHOTO_BLK: (state, { payload }) => {
    let viewObject = state.get('view');
    return state.merge({
      view: viewObject.set('showPhotoBlk', false)
    })
  },

  CLEAN_ALERT: (state, { payload }) => {
    return state.merge({
      alert: {
        style: null,
        message: null
      },
    })
  },

  CLEAN_CHECK_CARD_ALERT: (state, { payload }) => {
    return state.merge({
      alert: {
        style: null,
        message: null
      },
    })
  },

  RELOAD_MAINTENANCE_CARD: (state, { payload }) => {
    let viewObject = state.get('view');
    return state.merge({
      view: viewObject.set('card', payload.data),
      isLoadingPage: false
    })
  },

  FIND_CATEGORIES: (state, { payload }) => {
    let viewObject = state.get('view');
    return state.merge({
      view: viewObject.set('categories', payload.data)
    })
  },

  FIND_MAINTENANCE_DETAILS: (state, { payload }) => {
    let viewObject = state.get('view');
    return state.merge({
      view: viewObject.set('details', payload.data)
    })
  },

  SELECT_CATEGORY: (state, { payload }) => {
    let requestObject = state.get('request');
    requestObject = requestObject.set('note', '');
    requestObject = requestObject.set('category', payload);

    return state.merge({
      alert: {
        style: null,
        message: null
      },

      request: requestObject,
    })
  },

  SET_NOTE: (state, { payload }) => {
    let requestObject = state.get('request');
    return state.merge({
      alert: {
        style: null,
        message: null
      },
      request: requestObject.set(payload.param, payload.value)
    })
  },

  APPEND_CHECK_DETAIL: (state, { payload }) => {
    let viewObject = state.get('view');
    let requestObject = state.get('request');

    return state.merge({
      // alert: {
      //   style: 'info',
      //   message: '新增成功'
      // },
      request: requestObject.set('note', ''),

      view: viewObject.set('details', payload.data)
    })
  },

  COMPLETE_CLOTH_PANT_CHECKING: (state, { payload }) => {
    let viewObject = state.get('view');
    viewObject = viewObject.set('card', payload.data);
    return state.merge({
      alert: {
        style: payload.alertStyle,
        message: payload.displayMessage
      },
      view: viewObject,
    })
  },

  // 建議不再使用
  COMPLETE_CLOTH_PANT_DISCARD: (state, { payload }) => {
    let viewObject = state.get('view');
    viewObject = viewObject.set('card', payload.data);
    return state.merge({
      // alert: {
      //   style: payload.alertStyle,
      //   message: payload.displayMessage
      // },
      view: viewObject,
    })
  },

  // 標記未送修
  COMPLETE_CLOTH_PANT_NOT_DILIVERED: (state, { payload }) => {
    let viewObject = state.get('view');
    viewObject = viewObject.set('card', payload.data);
    return state.merge({
      // alert: {
      //   style: payload.alertStyle,
      //   message: payload.displayMessage
      // },
      view: viewObject,
    })
  },

  // 將 TAB 重置到第一個TAB(消防衣) 
  RESET_CARD_CATEGORY: (state, { payload }) => {
    let requestModel = state.get('request');
    return state.merge({
      request: requestModel.set('category', 0)
    })
  },

  // 驗證新增 RFID READER
  VALIDATE_CREATE_RFID_READER: (state, { payload }) => {
    return state.merge({
      validation: payload.data.valBean
    })
  },

  // 頁面 LOADING
  LOADING_PAGE: (state, { payload }) => {
    return state.merge({
      isLoadingPage: payload,
    })
  },

  // change 洗標條碼
  CHANGE_CHECK_CARD_LABEL_ID: (state, { payload }) => {
    return state.merge({
      labelId: payload,
    })
  },

  // 顯示 label 輸入框
  SHOW_INPUT_LABEL_ID: (state, { payload }) => {
    return state.merge({
      showInputLabelId: payload,
    })
  },

  // 前一頁
  CHANGE_CHECK_CARD_PREVIOUS_PAGE: (state, { payload }) => {
		return state.merge({
			previousPage: payload
		})
	},

}, CheckCardState);

export default checkCardReducer;


// WEBPACK FOOTER //
// ./src/reducers/checkCardReducer.js